module.exports = __webpack_public_path__ + "img/banner.34821b6a.png";